import Vue from 'vue';

function getFirstError(error, showMessageError) {
    if (!error.response.data) {
        return false;
    }

    if (showMessageError && error.response.data.message) {
        return error.response.data.message;
    }

    if (error.response.data.email) {
        return error.response.data.email;
    }

    const firstKey = Object.keys(error.response.data.errors)[0];

    if (!firstKey) {
        return false;
    }

    return error.response.data.errors[firstKey][0];
}

export default function handleErrors(error, showMessageError = false) {
    const firstError = getFirstError(error, showMessageError);

    if (firstError) {
        Vue.toasted.global.error({
            message: firstError,
        });
    } else if (error.response.data.message) {
        Vue.toasted.global.error({
            message: error.response.data.message,
        });
    } else {
        Vue.toasted.global.error();
    }
}
